import { FLOOR_AREA_MAX_OPTIONS, FLOOR_AREA_MIN_OPTIONS } from '../../constants/filterOptions';
import RangeAutocomplete from 'components/FilterFields/RangeAutocomplete';
import { validateDecimalPlaces, validateFloorArea, validateMaxLength } from 'lib/Validations';
import SearchFilterUtil from 'lib/SearchFilterUtil';

function FloorAreaFilter(props) {

    const validateInput = (input) => {
        return (
            validateFloorArea(input) ||
            validateMaxLength(input) ||
            validateDecimalPlaces(input)
        );
    };

    return (
        <RangeAutocomplete
            comparableType={props.comparableType}
            attrName="floorArea"
            label="Floor Area"
            subLabel="Select an option or manually enter a value"
            minOptions={FLOOR_AREA_MIN_OPTIONS}
            maxOptions={FLOOR_AREA_MAX_OPTIONS}
            maxInputLength={18}
            isDropdown={false}
            formatter={SearchFilterUtil.expandAndFormatArea}
            validateInput={validateInput}
        />
    );
}

export default FloorAreaFilter;